module.exports = __webpack_public_path__ + "static/media/left-cat-arrow.96e61747.svg";